import { useTranslation } from '@chr/online-shared-ui-localizations';
import { MapPagedPanel, MenuItem } from '@chr/online-shared-ui-maps';
import {
  AffectedAreaIcon,
  CompletedDestinationIcon,
  CompletedStopIcon,
  PlannedDestinationIcon,
  PlannedStopIcon,
  RouteRemainingIcon,
  RouteTraveledIcon,
} from './MapIcons';
import { Stack, Typography } from '@mui/material';
import { MapControlSection } from './MapControlSection';

type MapKeyProps = {
  onClose: () => void;
};

export const MapKey = ({ onClose }: MapKeyProps) => {
  const translate = useTranslation();

  return (
    <>
      <MapPagedPanel
        onClose={onClose}
        data-testid="map-key-panel"
        sx={{
          padding: '16px 16px 4px',
          backgroundColor: 'background.paper',
          borderColor: 'background.paper',
          color: 'text.primary',
          position: 'absolute',
          bottom: 80,
          right: 30,
          '.MuiTypography-subtitle1': {
            fontWeight: 600,
            fontSize: '14px'
          }
        }}
      >
        <MapControlSection title={translate('Stop Types')} data-testid="stop-types-panel">
          <Stack gap={1} sx={{ justifyContent: 'space-between' }}>
            <MenuItem
              label={translate('Stop - Not Complete')}
              icon={<PlannedStopIcon />}
              testId="planned-stop"
            />
            <MenuItem
              label={translate('Stop - Complete')}
              icon={<CompletedStopIcon />}
              testId="completed-stop"
            />
            <MenuItem
              label={translate('Destination - Not delivered')}
              icon={<PlannedDestinationIcon />}
              testId="planned-destination"
            />
            <MenuItem
              label={translate('Destination - Delivered')}
              icon={<CompletedDestinationIcon />}
              testId="completed-destination"
            />
          </Stack>
        </MapControlSection>
        <MapControlSection title={translate('Disruptions')} data-testid="disruption-panel">
          <Stack gap={1} sx={{ justifyContent: 'space-between', paddingBottom: '16px' }}>
            <MenuItem label={translate('Affected Area')} icon={<AffectedAreaIcon />} testId={'affected-area'} />
          </Stack>
          <Stack gap={1} sx={{ justifyContent: 'space-between' }}>
            <Typography variant="subtitle1" color="text.primary" sx={{ padding: '6px 4px' }}>
              {translate('Route')}
            </Typography>
            <MenuItem
              label={translate('Route Traveled')}
              icon={<RouteTraveledIcon />}
              testId={'route-traveled'}
            />
            <MenuItem
              label={translate('Route Remaining')}
              icon={<RouteRemainingIcon />}
              testId={'route-remaining'}
            />
          </Stack>
        </MapControlSection>
      </MapPagedPanel>
    </>
  );
};
